import React, { useCallback, useMemo } from 'react'
import { format } from 'date-fns'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import PdfGeneration from '../../../../../features/components/PdfGeneration'
import DateRangeWithStaticList from '../../../../../features/components/DateRange/DateRangeWithStaticList'
import PartnerbrainToggle from '../../../../../features/components/PartnerbrainToggle'
import ExportAsCsvReport from '../../../../../forms/Facebook/ExportAsCsvReport'

import { getReportPDFSections } from './generateReport'
import { getDateRangePDFReportLabel } from '../../../../../features/components/DateRange/helpers'

import { updateRight } from '../../../../../modules/actions/rights'
import { setCombinedDataDateRange } from '../../../../../modules/actions/combinedData'
import { rightSelector, rightWasLoadedSelector } from '../../../../../modules/selectors/rights'
import {
  combinedCampaignsErrorSelector,
  combinedCampaignsSelector,
  combinedCampaignsWasLoadedSelector,
  combinedDataDateRangeSelector
} from '../../../../../modules/selectors/combinedData'
import { FACEBOOK_PROVIDER_PLATFORM } from '../../../../../constants/selectLists/platformList'

const RightCampaignsListActions = ({ selectedCampaigns }) => {
  const dispatch = useDispatch()

  const combinedDataDateRange = useSelector(combinedDataDateRangeSelector)
  const { id: rightId, partnerbrain: isPartnerbrainToggled, name } = useSelector(rightSelector)
  const rightWasLoaded = useSelector(rightWasLoadedSelector)
  const combinedCampaignsWasLoaded = useSelector(combinedCampaignsWasLoadedSelector)
  const combinedCampaignsError = useSelector(combinedCampaignsErrorSelector)
  const combinedCampaigns = useSelector(combinedCampaignsSelector)

  const facebookCampaignsIds = useMemo(() => {
    return combinedCampaigns?.campaigns
      ?.filter(item => item.provider === FACEBOOK_PROVIDER_PLATFORM)
      .map(item => item.id)
  }, [combinedCampaigns])

  const dateRangeLabel = getDateRangePDFReportLabel(combinedDataDateRange)

  const partnerbrainToggleHandler = useCallback(
    isPartnerbrainToggled => {
      dispatch(
        updateRight(rightId, {
          partnerbrain: isPartnerbrainToggled
        })
      )
    },
    [dispatch, rightId]
  )

  return rightWasLoaded && (combinedCampaignsWasLoaded || combinedCampaignsError) ? (
    <>
      {facebookCampaignsIds?.length > 0 && (
        // ExportAsCsvReport currently is supports only FB platform
        <ExportAsCsvReport
          dateRangeSelector={combinedDataDateRangeSelector}
          campaignsIds={selectedCampaigns.length ? selectedCampaigns : facebookCampaignsIds}
          level="campaign"
        />
      )}
      <PartnerbrainToggle isInitiallyEnabled={isPartnerbrainToggled} onEnableAction={partnerbrainToggleHandler} />
      {!combinedCampaignsError && (
        <DateRangeWithStaticList
          setDateRangeAction={setCombinedDataDateRange}
          dateRangeSelector={combinedDataDateRangeSelector}
        />
      )}
      <PdfGeneration
        dateRangeLabel={dateRangeLabel}
        title={name}
        getReportPDFSections={getReportPDFSections}
        fileName={`Right ${rightId} - generated ${format(new Date(), 'dd-MMM-yyyy')}`}
      />
    </>
  ) : (
    <>
      <Skeleton width={245} height={16} />
      <Skeleton width={210} height={16} />
    </>
  )
}

export default RightCampaignsListActions
